// services/axios.js
import axios from "axios";
import { API_BASE_URL } from "../constants/config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add auth token interceptor
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["x-access-token"] = `${token}`;
  }
  return config;
});

export default axiosInstance;
